<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Journals</h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row" v-show="!isEdit">
        <div class="pl-3 col">
          <v-text-field
            id="searchPublication"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col">
          <v-select
            id="subscriptionType"
            v-model="paging.isASC"
            :items="[{type:'Ascending', value: true}, {type:'Descending', value: false}]"
            label="Order By"
            item-text="type"
            item-value="value"
            return-value="type"
            @change="getCollectionByPagin()"
          ></v-select>
        </div>
        <div class="col"></div>
        <div class="col pl-2">
          <div class="float-right">
            <v-btn color="primary" @click="onNew()" class="mt-4" id="btnNew">
              New Journal
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="isEdit">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="row">
            <div class="col">
              <v-text-field
                id="ISSN"
                v-model="selectedObj.ISSN"
                :rules="ISSNRules"
                label="ISSN *"
                required
              ></v-text-field>
            </div>
            <div class="col">
              <v-text-field
                id="Title"
                v-model="selectedObj.Title"
                label="Title*"
                :rules="TitleRules"
                required
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-select
                id="Publisher"
                v-model="selectedObj.Publisher"
                :items="publishers"
                label="Journal Provider"
                item-text="Name"
                item-value="Name"
                return-value="Name"
              ></v-select>
            </div>
            <div class="col">
              <v-text-field
                id="Organization"
                v-model="selectedObj.Organization"
                label="Organization"
              ></v-text-field>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-textarea
                id="Scope"
                v-model="selectedObj.Scope"
                label="Areas"
                max="1000"
              ></v-textarea>
            </div>
          </div>

          <v-divider class="pt-5"></v-divider>
          <!-- <h3 class="mt-5">Journal File & Thumbnail</h3>

          <div class="row">
            <div class="col">
              <file-drop
                v-on:update="logFiles($event)"
                v-on:clear="clearFile"
                :fileName="fileName"
                id="dropFile"
              ></file-drop>
              <div v-show="fileSize > 0">Size: {{ this.fileSize }} MB</div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <v-checkbox
                id="default"
                v-model="isDefaultThumbnail"
                label="Use default thumbnail"
                @change="isDefaultThumbnailChanged"
              ></v-checkbox>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-10">
                  <v-file-input
                    id="ThumbnailImage"
                    accept="image/png, image/jpeg"
                    placeholder="Thumbnail"
                    prepend-icon="mdi-camera"
                    label="Thumbnail*"
                    v-model="thumbnailData"
                    @change="loadTumbnail"
                    @click:clear="clearFile"
                    required
                    v-show="!isDefaultThumbnail"
                  ></v-file-input>
                </div>
                <div class="col-2 ThumbnailImg" style="width: 50px">
                  <div class="float-right">
                    <img
                      :src="ThumbnailPath"
                      width="50"
                      id="thubnailImageview"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <v-divider class="pt-5"></v-divider> -->

          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <div class="d-flex justify-space-between align-center">
                      <span @click="sortTitle" style="cursor: pointer;">
                        Numbers/Issues
                      </span>

                      <v-btn
                        text
                        small
                        color="primary"
                        @click.stop="newJournalDialog = true"
                      >
                        New Number/Issue
                      </v-btn>
                    </div>
                  </th>
                </tr>
                <!-- <tr> -->
                  <!-- <th class="text-left" @click="sortTitle" style="cursor: pointer;">Number/Issues</th> -->
                  
                  <!-- <th class="text-left" @click="sortInstitution" style="cursor: pointer;">Institution</th> -->
                  <!-- <th class="text-left" @click="sortISSN" style="cursor: pointer;">ISSN</th> -->
                  <!-- <th style="width: 100px"></th> -->
                <!-- </tr> -->
              </thead>
              <tbody>
                <tr v-for="item in collectionList" :key="item.id" :id="'svg' + i">
                  <td>
                    {{ item.Title }}
                    <!-- <dvi> -->
                      <v-icon class="mr-2 icon-delete float-right" @click="onDelete(item)"
                      >mdi-delete</v-icon
                    >
                    <v-icon class="mr-2 icon-edit float-right" @click="onEditJournal(item)"
                      >mdi-comment-edit</v-icon
                    > 
                    <!-- </dvi> -->
                  </td>
                  
                  
                  <!-- <td>
                    {{ item.Publisher != null ? item.Publisher : "" }}
                  </td> -->
                  <!-- <td>{{ item.ISSN }}</td> -->
                  <!-- <td>
                    
                  </td> -->
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-dialog v-model="newJournalDialog" max-width="900">
          <v-card>
            <v-card-title>New Journal</v-card-title>
            <v-card-text>
              <v-form ref="newJournalForm" v-model="newJournalValid" lazy-validation>
                <div class="row">
                  <div class="col">
                    <v-text-field
                      id="newJournalTitle"
                      v-model="newJournal.Title"
                      :rules="TitleRules"
                      label="Volume *"
                      required
                    ></v-text-field>
                  </div>
                </div>

                <v-divider class="pt-5"></v-divider>
                <h3 class="mt-5">Journal File & Thumbnail</h3>

                <div class="row">
                  <div class="col">
                    <file-drop
                      v-on:update="onNewJournalFile"
                      v-on:clear="clearNewJournalFile"
                      :fileName="newJournal.fileName"
                      id="dropNewJournalFile"
                    ></file-drop>
                    <div v-show="newJournalFileSize > 0">
                      Size: {{ newJournalFileSize }} MB
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-checkbox
                      id="newJournalDefaultThumbnail"
                      v-model="newJournal.isDefaultThumbnail"
                      label="Use default thumbnail"
                      @change="onNewJournalDefaultThumbnail"
                    ></v-checkbox>
                  </div>
                  <div class="col">
                    <div class="row">
                      <div class="col-10">
                        <v-file-input
                          id="newJournalThumbnail"
                          accept="image/png, image/jpeg"
                          placeholder="Thumbnail"
                          prepend-icon="mdi-camera"
                          label="Thumbnail *"
                          v-model="newJournal.thumbnailData"
                          @change="onNewJournalThumbnail"
                          v-show="!newJournal.isDefaultThumbnail"
                          class="mt-5"
                        ></v-file-input>
                      </div>
                      <div class="col-2 ThumbnailImg" style="width: 50px">
                        <div class="float-right">
                          <img
                            :src="newJournal.ThumbnailPath"
                            width="50"
                            id="newJournalThumbnailPreview"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-form>

              <div v-if="draftJournals.length" class="mt-4">
                <h4>Added Journals</h4>
                <v-simple-table class="mt-2">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Title</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in draftJournals" :key="item.tempId || index">
                        <td>{{ item.Title }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancelNewJournalDialog">Cancel</v-btn>
              <v-btn color="primary" @click="addDraftJournal" :disabled="!canAddDraftJournal">Add</v-btn>
              <v-btn
                color="primary"
                :loading="newJournalSaving"
                :disabled="newJournalSaving || !draftJournals.length"
                @click="saveDraftJournals"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

          <div class="row mb-4">
            <div class="col">
              <div class="float-right action-area">
                <v-btn @click="onCancel()" id="btnCancel"> Cancel </v-btn>
                <v-btn
                  id="btnSave"
                  class="mr-4"
                  color="primary"
                  @click="onSave()"
                  :loading="loading"
                  :disabled="loading"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="row mt-5" v-show="!isEdit">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <PublicationList ref="publicationList" />
          <!--loading screen untill the publications is completely  loaded-->
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" @click="sortByName" style="cursor: pointer;">Name</th>
                  <th class="text-left" @click="sortByType" style="cursor: pointer;">ISSN</th>
                  <th class="text-left" @click="sortByPublisher" style="cursor: pointer;">Journal Provider</th>
                  <th class="text-left" @click="sortByCreatedAt"  style="cursor: pointer;">
                    Created
                  </th>
                  <th class="text-left" @click="sortByUpdatedAt"  style="cursor: pointer;">
                    Modified
                  </th>
                  <th class="text-center" @click="sortByItemCount" style="width: 100px; cursor: pointer;">
                    # of Journals
                  </th>
                  <!-- <th style="width: 100px">Price</th> -->
                  <!--  <th style="width: 100px">No of Seat</th> -->
                  <th style="width: 150px" class="ml-10"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id" :id="'collection' + item.id">
                  <td>{{ item.Name }}</td>
                  <td> {{ item.issn}}</td>
                  <td>{{ item.publisher }}</td>
                  <td>{{item.createDateTime | dateUtcToLocal }}</td>
                  <td>{{ item.modifiedDateTime | dateUtcToLocal }}</td>
                  <td>
                    <div class="d-flex justify-center">
                      <!-- number of books/journals -->
                      {{ item.collectionType === 1 ? item.publicationcount : item.journalcount || 0 }}
                    </div>
                  </td>
                  <!-- <td class="text-right">{{ item.Price }}</td> -->
                  <!--   <td class="text-right">{{ item.Seat }}</td> -->
                  <td>
                    <v-icon class="mr-1 icon-edit" @click="onEdit(item)"
                      >mdi-comment-edit</v-icon
                    >
                    <v-icon class="mr-1 icon-delete" @click="DeleleJournalCollection(item)"
                      >mdi-delete</v-icon
                    >
                    <v-icon
                          class="mr-1"
                          @click="getCollectionList(item.id, item.collectionType)">
                          mdi-view-grid-outline
                    </v-icon>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row" v-show="!isEdit">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import lodash from "lodash";
import Notification from "@/components/Notification";
import FileDrop from "../components/FileDrop";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import VueUploadComponent from "vue-upload-component";
import Pagination from "@/components/Pagination";
import UploadingStatus from "../components/UploadingStatus.vue";
import PublicationList from "../components/PublicationList.vue";
import * as api from "@/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Journals",
  components: {
    Notification,
    FileUpload: VueUploadComponent,
    FileDrop,
    ConfirmationDialog,
    Pagination,
    UploadingStatus,
    PublicationList,
  },
  computed: {
    canAddDraftJournal() {
      const hasTitle = (this.newJournal.Title || "").trim().length > 0;
      const hasFile = !!this.newJournal.file && !!this.newJournal.fileName;
      const hasThumbnail =
        this.newJournal.isDefaultThumbnail ||
        !!this.newJournal.thumbnailData ||
        !!this.newJournal.thumbnail;

      // Treat ISSN as required since you already validate it elsewhere
      return hasTitle && hasFile && hasThumbnail;
    }
  },
  created() {
    this.getCollectionByPagin();
    // this.getJournalsByPagin();
    this.getJournals();
    this.getPublishers();
  },
  methods: {
    getJournals() {
      let that = this;
      that.overlay = true;
      this.users = [];
      new Promise((resolve, reject) => {
        api
          .getAll("Journal")
          .then(response => {
            console.log(response);
            this.journals = response.data;

            for (let i = 0; i < this.journals.length; i++) {
              this.journals[i].IsSelected = false;
              if (this.journals[i].Publisher == null)
                this.journals[i].Publisher = "";
            }
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getPublishers() {
      this.publishers = [];
      new Promise((resolve, reject) => {
        api
          .getAll("institutions")
          .then((response) => {
            this.publishers = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onNextPage(page) {
      this.paging.page = page;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onNew() {
      this.isEdit = true;
      this.id = 0;
      this.uuid = 'J-' + uuidv4();
      this.selectedObj = Object.assign({}, null);
      this.selectedObj.id = 0;
      this.thumbnailFileName = "";
      this.selectedObj.isCoreCollection = false;
      this.$refs.form.reset();
      this.collectionList = [];
      this.cartItems.splice(0, this.cartItems.length);
      this.draftJournals = [];
    },
    onEditJournal(obj) {
      this.newJournalDialog = true;
      this.newJournal = {
        id: obj.id,
        Title: obj.Title,
        file: null,
        thumbnail: null,
        isDefaultThumbnail: false,
        thumbnailData: null,
      };
    },
    onEdit(obj) {
      this.$refs.form.resetValidation();
      this.isEdit = true;
      this.cartItems.splice(0, this.cartItems.length);
      this.id = obj.id;
      this.journalTypesSelected = { id: obj.JournalType };
      obj.file = {};
      this.selectedObj = Object.assign({}, obj);
      this.uuid = obj.uuid;
      this.ThumbnailFileType = obj.ThumbnailFileType;
      this.isDefaultThumbnail = obj.isDefaultThumbnail;
      this.ThumbnailPath = obj.ThumbnailPath;
      this.ThumbnailPathOld = obj.ThumbnailPath;
      const results = this.getCollectionList(obj.id, 0);
      this.getJournalCollection(obj.id);
      this.selectedObj.Title = obj.Name;
      this.draftJournals = [];
    },
    getJournalCollection(id) {
      let that = this;
      that.overlay = true;
      this.selectedObj.journals = [];
      for (let i = 0; i < this.journals.length; i++) {
        this.journals[i].IsSelected = false;
      }
      new Promise((resolve, reject) => {
        api
          .getByID("journal-collection/journal", id)
          .then(response => {
            console.log("cart data id: ", response.data);
            that.cartItems.splice(0, that.cartItems.length);
            for (let i = 0; i < response.data.length; i++) {
              var objIndex = that.journals.findIndex(
                p => p.id == response.data[i].id
              );
              that.journals[objIndex].IsSelected = true;
              that.cartItems.push(that.journals[objIndex]);
            }
            // ensure cartItems has at least one item and use Vue reactivity helpers
            if (that.cartItems && that.cartItems.length > 0) {
              const first = that.cartItems[0];
              // use $set so Vue detects new/changed props on selectedObj
              this.$set(this.selectedObj, 'ISSN', first.ISSN);
              this.$set(this.selectedObj, 'Publisher', first.Publisher);
              this.$set(this.selectedObj, 'Organization', first.Organization);
              this.$set(this.selectedObj, 'Scope', first.Scope);
            }
            that.SearchPublication = " ";
            that.SearchPublication = "";
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    addDraftJournal() {
      // if (!this.isIssnComplete) {
      //   this.notify.type = 4;
      //   this.notify.errors = ["Please enter a complete ISSN (e.g. 1234-5678)."];
      //   return;
      // }

      this.newJournal.ISSN = this.selectedObj.ISSN;
      this.newJournal.Publisher = this.selectedObj.Publisher;
      this.newJournal.Organization = this.selectedObj.Organization;
      this.newJournal.Scope = this.selectedObj.Scope;
      const draftErrors = this.getJournalDraftErrors(this.newJournal);
      if (draftErrors.length) {
        this.notify.type = 4;
        this.notify.errors = draftErrors;
        return;
      }

      if (this.$refs.newJournalForm) {
        const isValid = this.$refs.newJournalForm.validate();
        if (!isValid) return;
      }

      const draft = Object.assign({}, this.newJournal, {
        tempId: Date.now()
      });

      this.draftJournals.push(draft);
      this.resetNewJournalForm();
    },
    onSave() {
      let that = this;
      this.notify.type = 0;
      this.notify.errors = [];
      
      this.selectedObj.journals = [];
      for (let i = 0; i < that.cartItems.length; i++) {
        let obj = Object.assign({}, that.cartItems[i]);
        this.selectedObj.journals.push(obj);
      }

      if (this.selectedObj.isCoreCollection == null) {
        this.selectedObj.isCoreCollection = false;
      }

      this.selectedObj.collectionType = 2;
      this.selectedObj.Description = this.selectedObj.Title;
      this.selectedObj.Name = this.selectedObj.Title;
      
       
      console.log(this.selectedObj);
      this.$refs.form.validate();

      if (this.selectedObj.Description == null || this.selectedObj.Description.length < 1 || !this.valid) return;

      if (this.cartItems.length <= 0) {
        this.notify.type = 4;
        this.notify.errors.push("Please add publications or journals.");
        return;
      }
      this.loading = true;
      that.overlay = true;
      console.log("updated cart",that.selectedObj);
      new Promise((resolve, reject) => {
        api
          .update("collection", this.selectedObj)
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              this.notify.type = 1;
              this.notify.message =
                this.selectedObj.id === -1
                  ? "Record successfully saved."
                  : "Record successfully updated.";
              setTimeout(() => {
                this.loading = false;
                this.isEdit = false;
                this.cartItems = [];
                this.getCollectionByPagin();
                this.notify.type = 0;
              }, 3000);
              that.getCollectionList(this.selectedObj.id, 0).then(() => {
              for (let i = 0; i < this.collectionList.length; i++) {
                this.collectionList[i].Publisher = this.selectedObj.Publisher;
                this.collectionList[i].Organization = this.selectedObj.Organization;
                this.collectionList[i].Scope = this.selectedObj.Scope;
                this.saveSingleJournal(this.collectionList[i]);
              }
            });
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data.");
              this.loading = false;
            }
            resolve(response);
            that.overlay = false;
            that.getCollectionList(this.selectedObj.id, 0)
          })
          .catch(error => {
            that.overlay = false;
            console.log(error);
            if (error.response.status == 409) {
              this.notify.type = 4;
              this.notify.errors.push("Collections name already exist");
              this.loading = false;
            } else {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              this.loading = false;
            }
            reject(error);
          });
      });
    },
    getCollectionByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("collection/journal", this.paging)
          .then(async response => {
            console.log(response);
            this.paging.count = response.data.count;
            this.list = response.data.data;
            that.overlay = false;
          })
          .catch(error => {
            that.overlay = false;
            reject(error);
          });
      });
    },
    getCollectionList(collectionId, collectionType) {
    let endpoint = '';
    endpoint = "journal-collection/journal";
    return new Promise((resolve, reject) => {
      api
        .getByID(endpoint, collectionId)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.collectionList = [];
            this.collectionList = response.data;
            if (collectionType === 2) {
              this.$refs.publicationList.open(response.data, collectionType); // Pass collectionType here
            }
          }
          resolve(response.data);
        })
        .catch((error) => {
          console.error("Error fetching collection items:", error);
          reject(error);
        });
    });
    },
    async DeleleJournalCollection(item) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("collection", item.id)
            .then(response => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                this.getCollectionByPagin();
                setTimeout(() => {
                  this.notify.type = 0;
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch(error => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
    },
    onCancel() {
      this.isEdit = false;
      this.$refs.form.reset();
      this.notify.errors.splice(0, this.notify.errors.length);
    },
    async onDelete(obj) {
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure, Do you really want to delete this record?"
        )
      ) {
        new Promise((resolve, reject) => {
          api
            .DeleteByID("journal", obj.id)
            .then((response) => {
              resolve(response);
              if (response.status === 200 || response.status === 201) {
                this.collectionList = this.collectionList.filter((x) => x.id !== obj.id);
                this.cartItems = this.cartItems.filter((x) => x.id !== obj.id);
                this.notify.type = 1;
                this.notify.message = "Record successfully deleted";
                setTimeout(() => {
                  this.notify.type = 0;
                  // this.getJournalsByPagin();
                }, 3000);
              } else {
                this.notify.type = 4;
                this.notify.errors.push("Failed to save data.");
              }
            })
            .catch((error) => {
              this.notify.type = 4;
              this.notify.errors.push("Failed to save data. " + error);
              reject(error);
            });
        });
      }
      this.isEdit = true;
    },
    getJournalsByPagin() {
      let that = this;
      that.overlay = true;
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getByPagin("journal", this.paging)
          .then((response) => {
            that.overlay = false;
            console.log(response.data.data);
            this.list = response.data.data;
            this.paging.count = response.data.count;
          })
          .catch((error) => {
            that.overlay = false;
            reject(error);
          });
      });
    },

    logFiles(fileList) {
      this.fileSize = 0;
      console.log(fileList);
      this.fileName = fileList[0].name;
      this.journal_file_length = fileList[0].size;
      console.log(this.fileName);
      console.log(fileList[0].size);
      this.file = fileList[0]; 
      this.selectedObj.journal_file_length = fileList[0].size;

      this.fileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    clearFile() {
      this.ThumbnailPath = "";
      this.fileSize = false;
    },
    loadTumbnail(e) {
      this.thumbnailFileName = this.thumbnailData.name;
      const reader = new FileReader();
      reader.readAsDataURL(this.thumbnailData);
      //reader.onload = () => resolve(reader.result); // reader.result
      reader.onload = (result) => {
        console.log(result.currentTarget.result);
        this.thumbnail = result.currentTarget.result;
        this.ThumbnailPath = result.currentTarget.result;
      };
      reader.onerror = (error) => reject(error);
    },
    isDefaultThumbnailChanged() {
      if (this.isDefaultThumbnail) {
        this.thumbnailUrl = "File: Default_Thumbnail.jpg";
        this.ThumbnailPath =
          "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png";
      } else {
        this.thumbnailUrl =
          "File: " + this.uuid + "." + this.ThumbnailFileType == ""
            ? "jpg"
            : this.ThumbnailFileType;
        this.ThumbnailPath = this.ThumbnailPathOld;
      }
    },

    getJournalType(id) {
      switch (id) {
        case 1:
          return "Academic Journals";
        case 2:
          return "Personal Journals";
        case 3:
          return "Professional Journals";
      }
    },
      sortTitle() {
        this.titleSortAsc = !this.titleSortAsc;
        this.list = this.list.sort((a, b) => this.titleSortAsc ? a.Title.localeCompare(b.Title) : b.Title.localeCompare(a.Title));
      },
      sortInstitution() {
        this.institutionSortAsc = !this.institutionSortAsc;
        this.list = this.list.sort((a, b) => this.institutionSortAsc ? a.Publisher.localeCompare(b.Publisher) : b.Publisher.localeCompare(a.Publisher));
      },
      sortISSN() {
        this.issnSortAsc = !this.issnSortAsc;
        this.list = this.list.sort((a, b) => this.issnSortAsc ? a.ISSN.localeCompare(b.ISSN) : b.ISSN.localeCompare(a.ISSN));
  },
  openNewJournalDialog() {
      if (!this.isIssnComplete) {
        this.notify.type = 4;
        this.notify.errors = ["Please enter a complete ISSN (e.g. 1234-5678)."];
        return;
      }
      this.resetNewJournalForm();
      this.newJournalDialog = true;
    },
    resetNewJournalForm() {
      this.newJournal = {
        id: 0,
        Title: "",
        ISSN: this.selectedObj.ISSN || "",
        Publisher: "",
        Organization: "",
        Scope: "",
        file: null,
        fileName: "",
        journal_file_length: 0,
        thumbnail: "",
        thumbnailData: "",
        thumbnailFileName: "",
        ThumbnailFileType: "",
        ThumbnailPath: "",
        ThumbnailPathOld: "",
        isDefaultThumbnail: false,
        uuid: ""
      };
      this.newJournalFileSize = 0;
      if (this.$refs.newJournalForm) {
        this.$refs.newJournalForm.resetValidation();
      }
    },
    cancelNewJournalDialog() {
      this.newJournalDialog = false;
      this.draftJournals = [];
      this.resetNewJournalForm();
    },
    onNewJournalFile(fileList) {
      if (!fileList || !fileList.length) return;
      this.newJournal.file = fileList[0];
      this.newJournal.fileName = fileList[0].name;
      this.newJournal.journal_file_length = fileList[0].size;
      this.newJournalFileSize = (fileList[0].size / (1024 * 1024)).toFixed(2);
    },
    clearNewJournalFile() {
      this.newJournal.file = null;
      this.newJournal.fileName = "";
      this.newJournal.journal_file_length = 0;
      this.newJournalFileSize = 0;
    },
    onNewJournalThumbnail() {
      if (!this.newJournal.thumbnailData) return;
      this.newJournal.thumbnailFileName = this.newJournal.thumbnailData.name;
      const reader = new FileReader();
      reader.readAsDataURL(this.newJournal.thumbnailData);
      reader.onload = (result) => {
        this.newJournal.thumbnail = result.currentTarget.result;
        this.newJournal.ThumbnailPath = result.currentTarget.result;
        this.newJournal.ThumbnailPathOld = result.currentTarget.result;
      };
    },
    onNewJournalDefaultThumbnail() {
      if (this.newJournal.isDefaultThumbnail) {
        this.newJournal.ThumbnailPath =
          "https://storage.googleapis.com/prothumia/eBooks/Default_Thumbnail.png";
      } else {
        this.newJournal.ThumbnailPath = this.newJournal.ThumbnailPathOld || "";
      }
    },
    addDraftJournal() {
      // if (!this.isIssnComplete) {
      //   this.notify.type = 4;
      //   this.notify.errors = ["Please enter a complete ISSN (e.g. 1234-5678)."];
      //   return;
      // }

      this.newJournal.ISSN = this.selectedObj.ISSN;
      this.newJournal.Publisher = this.selectedObj.Publisher;
      this.newJournal.Organization = this.selectedObj.Organization;
      this.newJournal.Scope = this.selectedObj.Scope;
      const draftErrors = this.getJournalDraftErrors(this.newJournal);
      if (draftErrors.length) {
        this.notify.type = 4;
        this.notify.errors = draftErrors;
        return;
      }

      if (this.$refs.newJournalForm) {
        const isValid = this.$refs.newJournalForm.validate();
        if (!isValid) return;
      }

      const draft = Object.assign({}, this.newJournal, {
        tempId: Date.now()
      });

      this.draftJournals.push(draft);
      this.resetNewJournalForm();
    },
    async saveDraftJournals() {
      if (this.newJournalSaving) return;
      if (!this.draftJournals.length) {
        this.newJournalDialog = false;
        return;
      }

      const validationErrors = [];
      for (const draft of this.draftJournals) {
        const draftErrors = this.getJournalDraftErrors(draft);
        if (draftErrors.length) {
          const label = draft.Title ? `"${draft.Title}"` : "(untitled)";
          validationErrors.push(`Draft ${label}: ${draftErrors.join(" ")}`);
        }
      }

      if (validationErrors.length) {
        this.notify.type = 4;
        this.notify.errors = validationErrors;
        return;
      }

      this.newJournalSaving = true;
      this.overlay = true;
      this.notify.type = 0;
      this.notify.errors = [];

      try {
        const savedItems = [];
        for (const draft of this.draftJournals) {
          const saved = await this.saveSingleJournal(draft);
          if (saved && saved.id) {
            savedItems.push(saved);
          } else {
            savedItems.push(draft);
          }
        }

        if (savedItems.length) {
          for (const item of savedItems) {
            this.cartItems = this.cartItems.filter(x => x.id !== item.id);
              
            this.addToCart({
              id: item.id || item.uuid || Date.now(),
              Title: item.Title,
              ISSN: item.ISSN,
              PublisherName: item.Publisher
            });
            this.collectionList = this.collectionList.filter(x => x.id !== item.id);

            this.collectionList.push({
              id: item.id || item.uuid || Date.now(),
              Title: item.Title,
              ISSN: item.ISSN,
              PublisherName: item.Publisher
            });
          }
        }

        this.getJournals();
        this.draftJournals = [];
        this.newJournalDialog = false;
      } catch (error) {
        const message =
          (error && error.response && error.response.data &&
            (error.response.data.message || error.response.data.error)) ||
          (error && error.message) ||
          String(error);
        this.notify.type = 4;
        this.notify.errors.push("Failed to save journal data. " + message);
      } finally {
        this.newJournalSaving = false;
        this.overlay = false;
      }
    },
    getJournalDraftErrors(draft) {
      const errors = [];

      // if (!this.isIssnCompleteValue(draft.ISSN)) {
      //   errors.push("Complete ISSN is required (e.g. 1234-5678).");
      // }

      if (!draft.Title) {
        errors.push("Title is required.");
      }

      if (!draft.fileName || !draft.file) {
        errors.push("Journal file is required.");
      } else {
        const ext = draft.fileName.split(".").pop().toLowerCase();
        if (ext !== "pdf" && ext !== "epub") {
          errors.push("Invalid file type. Only .pdf or .epub allowed.");
        }
      }

      if (!draft.isDefaultThumbnail && !draft.thumbnail && !draft.thumbnailData) {
        errors.push("Thumbnail is required or choose default thumbnail.");
      }

      return errors;
    },
    async saveSingleJournal(draft) {
      const payload = {
        id: draft.id || 0,
        Title: draft.Title || "",
        ISSN: draft.ISSN || "",
        Publisher: draft.Publisher || "",
        Organization: draft.Organization || "",
        Scope: draft.Scope || "",
        isDefaultThumbnail: draft.isDefaultThumbnail || false,
        ThumbnailPath: draft.ThumbnailPath || "",
        ThumbnailFileType: draft.ThumbnailFileType || "",
        thumbnail: draft.thumbnail || "",
        thumbnailFileName: draft.thumbnailFileName || "",
        fileName: draft.fileName || "",
        journal_file_length: draft.journal_file_length || 0
      };

      payload.uuid = draft.uuid || "J-" + uuidv4();

      if (payload.thumbnailFileName) {
        payload.ThumbnailFileType = payload.thumbnailFileName.split(".").pop();
      }

      if (payload.ThumbnailPath && payload.ThumbnailPath.includes("data:image")) {
        payload.ThumbnailPath = "";
      }

      if (!payload.fileName) {
        const response = await api.update("journal", payload);
        if (response.status === 200 || response.status === 201) {
          return response.data || payload;
        }
        throw new Error("Failed to save journal.");
      }

      const fileExt = payload.fileName.split(".").pop().toLowerCase();
      const signedResponse = await api.post("journal/signed-url", {
        mimeType: fileExt,
        contentId: payload.uuid
      });

      if (signedResponse.status !== 200 && signedResponse.status !== 201) {
        throw new Error("Failed to upload file.");
      }

      await fetch(signedResponse.data.url, {
        method: "PUT",
        headers: {
          "Content-Type": fileExt
        },
        body: draft.file
      });

      const response = await api.update("journal", payload);
      if (response.status === 200 || response.status === 201) {
        return response.data || payload;
      }
      throw new Error("Failed to save journal.");
    },
    addToCart(item) {
      let that = this;
      if (lodash.find(that.cartItems, { id: item.id }) == undefined) {
        if (item.ISSN == undefined) { 
          that.cartItems.push({
            id: item.id,
            Title: item.Title,
            ISBN: item.ISBN,
            Publisher: item.PublisherName,
            Action: item.id
          });
        } else {
          that.cartItems.push({
            id: item.id,
            Title: item.Title,
            ISSN: item.ISSN,
            Publisher: item.PublisherName || item.Publisher,
            Action: item.id
          });
        }
      }
      //that.cartItems.push(Object.assign({}, item));
    },
    sortByName() {
    this.nameSortAsc = !this.nameSortAsc;
      this.list = this.list.sort((a, b) => this.nameSortAsc ? a.Name.localeCompare(b.Name) : b.Name.localeCompare(a.Name));
    },
    sortByType() {
      this.typeSortAsc = !this.typeSortAsc;
      this.list = this.list.sort((a, b) => this.typeSortAsc ? a.collectionType - b.collectionType : b.collectionType - a.collectionType);
    },
    sortByDescription() {
      this.descriptionSortAsc = !this.descriptionSortAsc;
      this.list = this.list.sort((a, b) => this.descriptionSortAsc ? a.Description.localeCompare(b.Description) : b.Description.localeCompare(a.Description));
    },
    
    sortByItemCount() {
      this.itemCountSortAsc = !this.itemCountSortAsc;
      this.list = this.list.sort((a, b) => this.itemCountSortAsc ? (a.itemCount || 0) - (b.itemCount || 0) : (b.itemCount || 0) - (a.itemCount || 0));
    },
    sortByCreatedAt() {
      this.createdAtSortAsc = !this.createdAtSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = new Date(a.createDateTime);
        const dateB = new Date(b.createDateTime);
        return this.createdAtSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    sortByUpdatedAt() {
      this.updatedAtSortAsc = !this.updatedAtSortAsc;
      this.list = this.list.sort((a, b) => {
        const dateA = new Date(a.modifiedDateTime);
        const dateB = new Date(b.modifiedDateTime);
        return this.updatedAtSortAsc ? dateA - dateB : dateB - dateA;
      });
    },
    sortByPublisher() {
      this.publisherSortAsc = !this.publisherSortAsc;
      this.list = this.list.sort((a, b) => this.publisherSortAsc ? a.publisher.localeCompare(b.publisher) : b.publisher.localeCompare(a.publisher));
    }
  },
  data: () => {
    return {
      id: 0,
      list: [],
      isEdit: false,
      isNew: false,
      Search: "",
      selectedObj: {
        id: 0,
        ISSN: "",
        Scope: "",
        
      },
      cartItems: [],
      uuid: "",
      journal_file_length: 0,
      journalTypes: [],
      journalTypesSelected: {},
      ISSNRules: [(v) => !!v || "ISSN is required"],
      TitleRules: [(v) => !!v || "Title is required"],
      JournalTypesRules: [(v) => !!v || "Journal types is required"],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      valid: false,
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "", isASC: true },
      files: [],
      file: {},
      fileName: "",
      thumbnailRules: [
        (v) =>
          (!!v && isDefaultThumbnail) ||
          "Thumbnail is required" ||
          !v ||
          v.size < 2000000 ||
          "Thumbnail size should be less than 2 MB!",
      ],
      isDefaultThumbnail: false,
      thumbnailUrl: "",
      fileSize: 0,
      thumbnailData: "",
      ThumbnailPath: "",
      ThumbnailPathOld: "",
      thumbnailFileName: "",
      newJournalDialog: false,
      newJournalValid: false,
      newJournalSaving: false,
      newJournalFileSize: 0,
      newJournal: {
        id: 0,
        Title: "",
        ISSN: "",
        Publisher: "",
        Organization: "",
        Scope: "",
        file: null,
        fileName: "",
        journal_file_length: 0,
        thumbnail: "",
        thumbnailData: "",
        thumbnailFileName: "",
        ThumbnailFileType: "",
        ThumbnailPath: "",
        ThumbnailPathOld: "",
        isDefaultThumbnail: false,
        uuid: ""
      },
      draftJournals: [],
      collectionList: [],
      journals: []
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/Journal.vue